import React from "react";
import CandidateProfile from "./CandidateProfile";
import InstitutionProfile from "./InstitutionProfile";
import CompanyProfile from "./CompanyProfile";
import RecruiterProfile from "./RecruiterProfile";

const ProfileResume = () => {
  const module = localStorage.getItem('Module')
  return (
    <>
      <div className="container">
        <div className="profile-resume-main-container">
          {module === 'Candidate' ? <CandidateProfile /> : module === 'Institution' ?
           <InstitutionProfile /> : module === 'Company' ? <CompanyProfile /> 
           : module === 'Recruiter' ? <RecruiterProfile /> : <CandidateProfile />}
        </div>
      </div>
    </>
  );
};

export default ProfileResume;
